import { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

type DashboardContextType = {
  startDate: Date;
  endDate: Date;
}

const DashboardContext = createContext<DashboardContextType>({} as DashboardContextType);

export const DashboardProvider = ({children, startDate, endDate}: {children: ReactNode, startDate: Date, endDate: Date}) => {

  return <DashboardContext.Provider value={{startDate, endDate}}>
    {children}
  </DashboardContext.Provider>;
};

export const useDashboardContext = () => useContext(DashboardContext);